import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-df-management',
  templateUrl: './df-management.component.html',
  styleUrls: ['./df-management.component.scss']
})
export class DfManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
